import Phaser, { Tilemaps } from "phaser";
import LifeLabel from '../ui/LifeLabel.js'
import GameOverScene from "./GameOverScene.js";
import LifeLabel2 from "../ui/LifeLabel2.js";
import WinningScene from "./WinningScene.js";
export default class EnemyBattlingScene extends Phaser.Scene
{
    constructor()
    {
        super('EnemyBattlingScene')
    }

    init()
    {
        this.gameHalfWidth = this.scale.width * 0.5
        this.gameHalfHeight = this.scale.height * 0.5
        this.player = undefined
        this.KnifeThrow = undefined
        this.enemy = undefined
        this.startGame = false
        this.questionText = undefined
        this.resultText = undefined
        this.StartButton = undefined
        this.option1 = undefined
        this.option2 = undefined
        this.option3 = undefined
        this.question = []
        this.questionText = undefined
        this.correctAnswer = undefined
        this.answer = undefined
        this.playerAttack = false
        this.enemyAttack = false
        this.scoreLabel = 0
        this.timerLabel = undefined
        this.countdownTimer = 60
        this.timedEvent = undefined
        this.lifeLabel = undefined
        this.lifeLabel2 = undefined
    }

    preload()
    {
      this.load.image('Background', 'images/Background.png')
      this.load.spritesheet('Boss', 'images/Boss.png',
      {frameWidth: 30.625, frameHeight: 28})
      this.load.spritesheet('EnemyLevel1', 'images/EnemyLevel1.png',
      {frameWidth: 15.375, frameHeight: 18})
      this.load.spritesheet('EnemyLevel2', 'images/EnemyLevel2.png',
      {frameWidth: 15.5, frameHeight: 18})
      this.load.spritesheet('EnemyLevel3', 'images/EnemyLevel3.png',
      {frameWidth: 15.375, frameHeight: 17})
      this.load.spritesheet('HealingPotion', 'images/HealingPotion.png',
      {frameWidth: 10, frameHeight: 13.5})
      this.load.spritesheet('Player', 'images/Player.png',
      {frameWidth: 15.9, frameHeight: 27})
      this.load.spritesheet('Hearts', 'images/Hearts.png',
      {frameWidth: 14.33, frameHeight: 10})
      this.load.image('Sword', 'images/Sword.png')
      this.load.image('Tilemap', 'images/Tilemap_Background.png')
      this.load.image('SpearThrow', 'images/Spear.png')
      this.load.image('KnifeThrow', 'images/Knife.png')
      this.load.audio('AdventureMusic', 'music/8Bit Adventure Loop.wav')
      this.load.audio('LosingMusic', 'music/Youlose.mp3')
      this.load.image('start-btn', 'images/Start_Button.png')
      this.load.spritesheet('Option', 'images/ABC.png',
      {frameWidth: 32, frameHeight: 32})
      this.load.image('Ground', 'images/backbackground.png')
      this.load.audio('WinningMusic', 'music/YouWin.wav')
      this.load.audio('Hurt', 'music/Hurt.wav')
      this.load.audio('ThrowK', 'music/ThrowK.wav')
    }

    create()
    {
        this.add.image(this.gameHalfWidth, this.gameHalfHeight, 'Ground')
        const fight_bg = this.add.image(240, 160, 'Background')
        const tile = this.physics.add.staticImage(240, fight_bg.height - 0, 'Tilemap')
        this.player = this.physics.add.sprite(
            this.gameHalfWidth - 150,
            this.gameHalfHeight - 250, 'Player'
        ).setBounce(0.2)
        this.physics.add.collider(this.player, tile)

        this.enemy = this.physics.add.sprite(
            this.gameHalfWidth + 150,
            this.gameHalfHeight - 250, 'EnemyLevel2'
        ).setBounce(0.2).setFlipX(true)

        this.physics.add.collider(this.enemy, tile)

        this.KnifeThrow = this.physics.add.sprite(240, 60, 'KnifeThrow') .setActive(false)
        .setVisible(false)
        .setGravityY(-500)
        .setOffset(0, -10)
        .setDepth(1)
        .setCollideWorldBounds(true)
        .setScale(3)
        let start_button = this.add.image(this.gameHalfWidth, this.gameHalfHeight + 200, 'start-btn').setInteractive().setScale(0.3)
        start_button.on('pointerdown', () => {
            this.gameStart()
            start_button.destroy()
            this.backsound = this.sound.add('AdventureMusic', {volume: 0.5})
            var soundConfig = {
            loop : true
        }
        this.backsound.play(soundConfig)
        }, this)
        this.createAnimation()
        this.physics.add.overlap(this.KnifeThrow, this.enemy, this.spriteHit, null, this)
        this.physics.add.overlap(this.KnifeThrow, this.player, this.spriteHit, null, this) 
        
    }

    update(time)
    {
        this.KnifeThrow.setScale(2)
        if(this.correctAnswer === true && !this.playerAttack)
        {
            this.time.delayedCall(0, () => {
                this.KnifeThrowed(this.player.x +60,this.player.y, 0, 600, true)
                this.sound.play("ThrowK")
            })
            this.playerAttack = true
            this.lifeLabel2.subtract(1)
            if (this.lifeLabel2.getLife() == 0)
            {
                this.scene.start("WinningScene")
                this.sound.stopAll()
                this.sound.play("WinningMusic")
            }
        }

        if(this.correctAnswer === undefined) {
            this.player.anims.play('player-standby', true)
            this.enemy.anims.play('enemy-standby', true)
            }

        if(this.correctAnswer === false && !this.enemyAttack)
        {
            this.time.delayedCall(0, () => {
                this.KnifeThrowed(this.enemy.x - 60, this.enemy.y, 2, -600, true)
                this.sound.play("ThrowK")
            })
            this.enemyAttack = true
            this.lifeLabel.subtract(1)
            if (this.lifeLabel.getLife() == 0)
            {
                this.scene.start("GameOverScene")
                this.sound.stopAll()
                this.sound.play("LosingMusic")

            }
        }
        this.player.setScale(3)
        this.enemy.setScale(3.5)
        //this.KnifeThrow.setScale(8)
    }

    gameStart()
    {
        this.startGame = true
        this.sound.stopAll()
        this.player.anims.play('player-standby', true)
        this.enemy.anims.play('enemy-standby', true)
        this.input.on('gameobjectdown', this.addAnswer, this) 
        this.questionText = this.add.text(this.gameHalfWidth,69, '0', { fontSize : '20px', fontFamily : 'arial', fill: '#fff'})
        this.createOptions()
        this.generateQuestion()
        this.lifeLabel = this.createLifeLabel(130, 425, 3)
        this.lifeLabel2 = this.createLifeLabel2(130, 585, 20)
        this.physics.add.overlap(this.KnifeThrow, this.enemy, this.spriteHit, null, this)
        this.physics.add.overlap(this.KnifeThrow, this.player, this.spriteHit, null, this) 
        render: {
            pixelArt: true
          }
    }

    createAnimation()
    {
        
        this.anims.create({
            key: 'player-standby',
            frames: this.anims.generateFrameNumbers('Player', {start: 0, end: 1}),
            frameRate: 1.6,
            repeat: -1
        })
        this.anims.create({
            key: 'enemy-standby',
            frames: this.anims.generateFrameNumbers('EnemyLevel2', {start: 0, end: 1}),
            frameRate: 1.6,
            repeat: -1
        })
    }

    createOptions() {
        this.option1 = this.add.image(100, 525, 'Option', 6)
        .setInteractive().setData('value', 'a').setScale(3)
        this.option2 = this.add.image(240, 525, 'Option', 10)
        .setInteractive().setData('value', 'b').setScale(3)
        this.option3 = this.add.image(380, 525, 'Option', 8)
        .setInteractive().setData('value', 'c').setScale(3)
    }

    getOperator() {
        const operator = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
        return operator[Phaser.Math.Between(0, operator.length - 1)]
    }

    addAnswer (pointer, object, event)
    {
        let value = object.getData('value')
        if (value == 'a')
        {
            this.answer = 'a'
            this.checkAnswer()
        }
        else if (value == 'b')
        {
            this.answer = 'b'
            this.checkAnswer()
        }
        else if (value == 'c')
        {
            this.answer = 'c'
            this.checkAnswer()
        }
        event.stopProgation()
    }
    
    generateQuestion()
    {
        let operator = this.getOperator()
        /*  Question Template
         else if (operator === '?')
        {
            this.question[0] = `Question
        A = ?
        B = ?
        C = ?`
        this.question[1] = '?'
        }
        */
        if (operator === '1')
        {
            this.question[0] = `Dimeja ada 3 apel, andi memakan 1 apel,
        tinggal berapa apelnya?
        A = 2
        B = 1
        C = 3`
        this.question[1] = 'a'
        }

        else if (operator === '2')
        {
            this.question[0] = `Apa bahasa inggrisnya kata "Celana"
        A = Pants
        B = Shirt
        C = Hat`
        this.question[1] = 'a'
        }

        else if (operator === '3')
        {
            this.question[0] = `Mengapa tv anda nyalakan?
        A = Nonton tv tersebut
        B = Menghancurkan tv
        C = Menjualnya`
        this.question[1] = 'a'
        }

        else if (operator === '4')
        {
            this.question[0] = `Mengapa saat kita mandi
            badan kita akan menjadi bersih?
        A = Karena kita mandi
        B = yntkts
        C = Kedua jawaban tersebut`
        this.question[1] = 'a'
        }

        else if (operator === '5')
        {
            this.question[0] = `andi punya 4 mangkok dipenuhi permen,
            andi memakan 2 mangkok,
            sekarang andi memiliki?
        A = 3 mangkok
        B = diabetes
        C = 1 mangkok`
        this.question[1] = 'b'
        }

        else if (operator === '6')
        {
            this.question[0] = `Mobil yang berwarna hitam di cet
            dengan cet berwarna putih,
            Berapa harga mobil tersebut
        A = Rp 300.000.000
        B = yntkts
        C = Rp 1`
        this.question[1] = 'b'
        }
        
        else if (operator === '7')
        {
            this.question[0] = `Berapa harga hp jika
            hp tersebut memiliki diskon 100%
        A = Rp -5632738
        B = Rp 0
        C = Kedua jawaban tersebut`
        this.question[1] = 'b'
        }

        else if (operator === '8')
        //ini disengajain hahhahahhahahhahah
        {
            this.question[0] = `insert_question
        A = insert_falseAnswer
        B = insert_correctAnswer
        C = insert_falseAnswer`
        this.question[1] = 'b'
        }

        else if (operator === '9')
        {
            this.question[0] = `Mengapa jeruk asam?
        A = Karena tidak manis
        B = Karena tidak pahit
        C = Kedua jawaban tersebut`
        this.question[1] = 'c'
        }

        else if (operator === '10')
        {
            this.question[0] = `Bonus question: pilih jawaban c
        A = pilih jawaban c
        B = pilih jawaban a
        C = pilih jawaban b`
        this.question[1] = 'c'
        }

        else if (operator === '11')
        {
            this.question[0] = `Meja memiliki massa 10 gb,
            Dengan velocity 10°C,
            Apa rumus pitagora?
        A = 29°C
        B = 300 mb
        C = a2 x b2 = c2`
        this.question[1] = 'c'
        }

        else if (operator === '12')
        {
            this.question[0] = `Apa bahasa russia
            "Rumah tersebut kebakar karena kebakar"
        A = Дом горит, не так ли? 
        B = Дом не загорелся, потому что он загорелся 
        C = Дом загорелся, потому что он загорелся`
        this.question[1] = 'c'
        }

        this.questionText.setText(this.question[0])
        const textHalfWidth = this.questionText.width * 0.5
        this.questionText.setX(this.gameHalfWidth - textHalfWidth)
    }

    checkAnswer()
    {
        if (this.answer == this.question[1])
        {
            this.correctAnswer = true
        } else {
            this.correctAnswer = false
        }
    }

    KnifeThrowed(x, y, frame,velocity, flip = false) {
        this.KnifeThrow.setPosition(x,y)
        .setActive(true)
        .setVisible(true)
        .setFrame(frame)
        .setVelocityX(velocity)
        .setFlipX(flip)
        }

    spriteHit(KnifeThrow, sprite)
    {
        KnifeThrow.x = 0
        KnifeThrow.y = 0
        KnifeThrow.setActive(false)
        KnifeThrow.setVisible(false)

        
        this.time.delayedCall(0, () => {
            this.playerAttack = false
            this.enemyAttack = false
            this.correctAnswer = undefined
            this.generateQuestion()
            }
        )
    }

    createLifeLabel(x, y, life)
    {
        const style = { fontSize: '32px', fontFamily : 'arial', fill: '#fff'}
        const label = new LifeLabel(this, x, y, life, style).setDepth(1)
        this.add.existing(label)
        return label
    }

    createLifeLabel2(x, y, life)
    {
        const style = { fontSize: '32px', fontFamily : 'arial', fill: '#fff'}
        const label = new LifeLabel2(this, x, y, life, style).setDepth(1)
        this.add.existing(label)
        return label
    }
}